import { Trans } from "@lingui/react/macro";
import { createFileRoute } from "@tanstack/react-router";

import { SearchesView } from "@/components/account/searches-view";

/**
 * Legacy /dashboard/searches — full saved-searches editor (pin, notify-me,
 * frequency picker, soft-delete + undo, run deep-link). Day 7 stub redirected
 * to /collections?tab=searches; R9 audit fix restores in-place rendering with
 * the same SearchesView shared component the Collections tab uses.
 */
export const Route = createFileRoute("/_authenticated/dashboard/searches")({
  component: DashboardSearchesPage,
});

function DashboardSearchesPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-foreground text-2xl font-semibold tracking-[-0.02em]">
          <Trans>Saved searches</Trans>
        </h1>
        <p className="text-muted-foreground mt-1 text-sm">
          <Trans>Pin, notify-me, and re-run with one tap.</Trans>
        </p>
      </header>
      <SearchesView showHeader={false} />
    </div>
  );
}
